<template>
  <div
    v-if="facts.length"
    :class="isBoxed ? 'px-box-4 mt-box-2 last:md:mb-box-2' : 'mask-wave-arc bg-white'"
    :data-widget-title="content.optionalTitle?.text"
  >
    <div :class="{ 'container py-16 md:py-20': !isBoxed }">
      <SliceTitle
        class="text-left"
        :class="isBoxed ? 'subtitle1' : 'title md:text-center lg:text-center'"
        :value="content.optionalTitle"
      />
      <PortableText
        v-if="content.optionalDescription"
        class="typography text-left mt-6"
        :class="{ 'md:text-center': !isBoxed }"
        :content="content.optionalDescription"
      />
      <table class="block rounded-8 md:bg-gray-50 md:p-box-2 md:-mx-box-2 mt-6">
        <tbody class="grid md:grid-cols-2 gap-x-12 gap-y-6">
          <tr v-for="(item, index) in facts" :key="index">
            <th class="block text-left font-bold mb-1">{{ item.fact }}</th>
            <td class="block">
              <PortableText class="typography no-top-spacing" :content="item.value" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toPlainText } from '@portabletext/vue'
import type { GQLKeyFactsSlice } from './generated/key-facts'

const props = defineProps<{ content: GQLKeyFactsSlice }>()

const facts = computed(() => {
  return props.content.facts.filter(
    ({ fact, value }) =>
      toPlainText(value) && !hasInvalidPlaceholderValue(fact) && !hasInvalidPlaceholderValue(value),
  )
})

const isBoxed = computed(() => props.content.layout.startsWith('boxed_'))
</script>
